import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import BaseListagem from "components/BaseListagem";
import dayjs from "dayjs";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import PedidoService from "service/producao/PedidoService";
import { converterData, converterDataHora } from "utils/convert";
import { DateMatchModeOptions, IdMatchModeOptions, ListMatchModeOptions, NumberMatchModeOptions, TextMatchModeOptions, dateFilterTemplate, filterApplyTemplate } from "utils/filterUtils";

const pedidoService = new PedidoService();

export default function PedidoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Pedidos');
    
    const [clientes, setClientes] = useState<any[]>([]);

    useEffect(() => {
        pedidoService.clientes().then(response => setClientes(response)).catch(() => setClientes([]));
    }, []);

    const defaultFilters: DataTableFilterMeta = {
        numeroPedido: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataHoraGeracao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataPrevista: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        cliente: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    

    const statusFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <MultiSelect value={options.value} options={pedidoService.getStatusPedidoFilter()} 
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)} 
            optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter" 
        />;
    };

    const clienteFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={clientes} 
            onChange={(e) => options.filterCallback(e.value)} 
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const numberFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <InputNumber 
            value={options.value} onValueChange={(e) => options.filterCallback(e.value)} 
            useGrouping={false} minFractionDigits={0} maxFractionDigits={0} 
            placeholder="Escreva o filtro"    
        />;
    }

    return (

        <BaseListagem ordenacao="numeroPedido,DESC" service={pedidoService} urlService="/pedido" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="pedido">
            <Column field="numeroPedido" header="Número" filter showFilterOperator={false} showAddButton={false} filterElement={numberFilterTemplate}
                filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="cliente.nome" header="Cliente" filter showFilterOperator={false} showAddButton={false}  filterField="cliente"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={clienteFilterTemplate} />
            <Column field="dataHoraGeracao" header="Geração" body={(rowData) => converterDataHora(rowData.dataHoraGeracao)} filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate} filterElement={dateFilterTemplate} filterMenuStyle={{zIndex: 50}} />
            <Column field="dataPrevista" header="Previsão" body={(rowData) => converterData(rowData.dataPrevista)} filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate} filterElement={dateFilterTemplate} filterMenuStyle={{zIndex: 50}} />
            <Column field="status" header="Status" body={(rowData) => pedidoService.getStatus(rowData.status)} filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={statusFilterTemplate} />
        </BaseListagem>
    )
}